import PropTypes from 'prop-types';
import React, { useRef, useEffect, useState } from 'react';

import Link from 'next/link';
import Headline from '../../atoms/headline/headline';
import ShortArrowDown from '../../icons/shortArrowDown.svg';
import StyledAnchorLinks from './anchorLinks.style';

const AnchorLinks = props => {
  const { links } = props;
  const anchorList = useRef(null);
  const [minHeight, setMinHeight] = useState(0);

  const handleClick = e => {
    const targetId = e.target.closest('button').getAttribute('data-target');
    const targetElement = document.getElementById(targetId);

    window.history.replaceState(null, null, `#${targetId}`);
    targetElement.scrollIntoView({ behavior: 'smooth' });

    setTimeout(() => {
      targetElement.setAttribute('tabindex', '-1');
      targetElement.focus();
    }, 1000);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleClick(e);
    }
  };

  useEffect(() => {
    const minHeightHeadlines = Array.from(
      document.querySelectorAll('.anchorLinks__headline')
    ).reduce((accumulator, headlineNode) => {
      if (accumulator < headlineNode.clientHeight) {
        return headlineNode.clientHeight;
      }
      return accumulator;
    }, 0);
    setMinHeight(minHeightHeadlines);
  }, []);

  return (
    <StyledAnchorLinks {...props} ref={anchorList}>
      <div className="anchorLinks__list">
        {links.map((link, index) => {
          return (
            <div key={index} className="anchorLinks__vertical-slice">
              {link.thinkingSpaceSlug && (
                <Link
                  href={{
                    pathname: link.thinkingSpaceSlug
                  }}
                >
                  <Headline
                    className="anchorLinks__headline"
                    main
                    tag="span"
                    style={{ minHeight }}
                    dangerouslySetInnerHTML={{ __html: link.label }}
                  ></Headline>
                </Link>
              )}
              {link.href && (
                <button
                  type="button"
                  key={link.label}
                  onClick={handleClick}
                  onKeyDown={handleKeyDown}
                  data-target={link.href}
                  className="anchorLinks__link"
                >
                  <ShortArrowDown width="22" height="22" aria-hidden="true" />
                  <Headline
                    dangerouslySetInnerHTML={{ __html: link.label }}
                    className="anchorLinks__headline"
                    subline
                    tag="span"
                  ></Headline>
                </button>
              )}
            </div>
          );
        })}
      </div>
    </StyledAnchorLinks>
  );
};

AnchorLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  )
};

export default AnchorLinks;
